module.exports = __webpack_public_path__ + "static/img/gri_980039_b07_f02_225_mm.95e9e1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/gri_980039_b07_f02_225_mm.jpg
// module id = 4Sls
// module chunks = 0